import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { UserInfo, UserRoleEnum } from '@/types/users';
import { useSimulationStore } from './useSimulationStore';

interface AuthState {
  isAuthenticated: boolean;
  setIsAuthenticated: (value: boolean) => void;
  user: UserInfo;
  setUser: (user: UserInfo) => void;
  resetStore: () => void;
  logout: () => void;
  showLogoutWarning: boolean;
  triggerLogoutWarning: () => void;
  dismissLogoutWarning: () => void;
}

const initialState = {
  isAuthenticated: false,
  user: {
    id: '',
    email: '',
    firstName: '',
    lastName: '',
    role: UserRoleEnum.ADMIN,
    isVerified: false,
    isOnboarded: false,
    phone: '',
    organizationName: '',
    organizationId: '',
    createdAt: '',
    status: false
  }
};

export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      ...initialState,
      setIsAuthenticated: (value: boolean) => set({ isAuthenticated: value }),
      setUser: (user: UserInfo) => set({ user: user }),
      resetStore: () => set(initialState),
      logout: () => {
        // Clear cookies
        document.cookie = 'accessToken=; path=/; expires=0;';
        document?.cookie?.split(';').forEach(c => {
          document.cookie = c.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });

        // Clear this store
        set(initialState);

        // Clear this store's persisted data
        useAuthStore.persist?.clearStorage?.();

        // Also clear simulation store and its storage
        useSimulationStore.getState().resetStore?.();
        useSimulationStore.persist?.clearStorage?.();

        // Reload or redirect
        window.location.href = '/login';
      },
      showLogoutWarning: false,
      triggerLogoutWarning: () => set({ showLogoutWarning: true }),
      dismissLogoutWarning: () => set({ showLogoutWarning: false })
    }),
    {
      name: 'practivated-storage',
      partialize: state => ({
        isAuthenticated: state.isAuthenticated,
        user: state.user
      })
    }
  )
);
